<style lang="stylus">
        .pcview-files-item-list
            width: 100%;
            height: 56px;
            font-size: 12px;
            cursor: pointer;
            position: relative;
            user-select: none;
            display: flex;
            align-items: center;
            border-radius 6px
            margin-bottom 4px
            >div
                color rgba(34, 34, 34, 0.40)
                textOverflow()
            &:hover
                background rgba(242, 244, 249, 0.60);
                .list-star
                    .list-star-block
                        display flex
                .filesitem-tag
                    display flex
                .file-name .file-checkbox
                    display flex
                .file-customtag
                    .file-customtag-arrow,p
                        display block
            .file-name
                pointer-events none
                width: 36.14%;
                display flex
                align-items center
                padding-left 24px
                .file-checkbox
                    display none
                    align-items center
                    justify-content center
                    position absolute
                    left 4px
                    width 16px
                    height 16px
                    cursor pointer
                    pointer-events auto

                    &.selected
                        display flex

                    .select-icon
                        display inline-block
                        width 16px
                        height 16px
                .file-icon
                    pointer-events auto
                    margin: 0;
                    width: 32px;
                    height: 32px;
                    flex-shrink 0
                    use
                        pointer-events none
                span
                    margin-left 8px
                    font-size 12px
                    color #222
                    margin-right: auto;
                    overflow hidden
                    white-space: nowrap;
                    text-overflow: ellipsis;

                .list-star
                    display flex
                    justify-content center
                    align-items center
                    width 22px
                    height 22px
                    margin-right 10px
                    pointer-events auto
                    flex-shrink 0
                    &.active
                        .list-star-block
                            display flex
                    .list-star-block
                        display none
                    svg
                        width 16px
                        height 16px
                        stroke #c4c4c4
                        fill none
                        &:not(.active):hover
                            stroke #c4c4c4
                            fill #c4c4c4
                        &.active:hover
                            stroke #FFC42C
                            fill #FFC42C
                        &.active
                            stroke #FFD056
                            fill #FFD056

            .file-time
                width 26.85%
            .file-customtag
                display flex
                align-items center
                width 18.51%
                height 100%
                cursor auto
                &.keep-expand
                    p
                        display block
                p
                    display none
                    max-width calc(100% - 10px)
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    cursor pointer

                .file-customtag-arrow
                    display none
                    margin-left 2px
                    width 8px
                    height 8px
                    cursor pointer
            .file-size
                width 9.25%
            .file-select
                width 9.25%
                display flex
                align-items center
                .list-star
                    display flex
                    justify-content center
                    align-items center
                    width 24px
                    height 24px
                    margin-right 8px
                    pointer-events auto
                    flex-shrink 0
                    &.active
                        .list-star-block
                            display flex
                    .list-star-block
                        display none
                    svg
                        width 16px
                        height 16px
                        stroke #c4c4c4
                        fill none
                        &:not(.active):hover
                            stroke #c4c4c4
                            fill #c4c4c4
                        &.active:hover
                            stroke #FFC42C
                            fill #FFC42C
                        &.active
                            stroke #FFD056
                            fill #FFD056


            .file-time-team
                width 30%
            .file-creator-team
                width 20%
            .file-size-team
                width 10%
            .list-viewonly
                display flex
                justify-content center
                align-items center
                flex-shrink 0
                border 1px solid rgba(0, 15, 38, 0.2)
                border-radius 5px
                padding 4px 8px
                width 80px
                margin-right 8px
                p
                    white-space nowrap
                    text-overflow ellipsis
                    overflow hidden
                    font-size 12px
                    color #222

        .publish-box
        	position absolute
        	left 38px
        	top 6px
        	display flex
        	justify-content space-around
        	align-items center
        	width 18px
        	height 18px
        	border-radius 50%
        	border 1px solid #f90
        	background #fff
        	.publish-icon
        		display block
        		width 10px
        		height 10px
        		fill #f90
        	&.active
        		border-color #017fff
        		.publish-icon
        			fill #017fff
        .pcview-files-list-star
            .file-name
                width 36%
            .file-time
                width 45%
            .file-size
                width 11.5%
            .file-select
                width 7.5%
        .pcview-files-list-sharetome
            .file-name
                width 36%
            .file-time
                width 27%
            .file-creator
                width 18.5%
            .file-permission
                width 18.5%
        .pcview-files-list-publish
            .file-name
                width 36%
            .file-time
                width 45.5%
            .file-pv
                width 18.5%
        .pcview-files-list-trash
            .file-name
                width 36%
            .file-time
                width 27%
            .file-size
                width 18.5%
            .file-notes
                width 18.5%
    .dark-theme_pcview-listfile
        >div
            color rgba(255, 255, 255, 0.40)
        &:hover
            background rgba(255, 255, 255, 0.08)
        .file-name
            span
                color #E6E6E6
            .list-viewonly
                border-color #c4c4c4
                p
                    color #E6E6E6
        .file-customtag
            color #e6e6e6
</style>

<template>
    <div
        class="pcview-files-item-list"
        :class="{
            'list-item-active': fileSelected.includes(index),
            'pcview-files-list-star': type == 'star',
            'pcview-files-list-sharetome': type == 'shareToMe',
            'pcview-files-list-publish': type == 'publishFile',
            'pcview-files-list-trash': type == 'recycle',
            'dark-theme_pcview-listfile': isPCDarkMode == 2,
        }"
        :data-index="index"
        :key="index"
        @contextmenu.prevent.stop="
            contextmenu($event, file, index);
            contextmenuEvent();
        "
        @click.exact="listFileClickEvent(index, file)"
        @click.ctrl.exact="ctrlSelect(index)"
    >
        <div class="file-name" :class="{ 'files-name': type == 'files' }">
            <div
                v-if="['files', 'openRecord', 'recycle'].includes(type) && !pcSaveInput"
                class="file-checkbox"
                :class="{ selected: fileSelected.includes(index) }"
                @mousedown.stop=""
                @click.stop="selectEvent(index)"
            >
                <img
                    :src="
                        require(`@/home/assets/pcview${isPCDarkMode == 2 ? '-dark' : ''}/check${fileSelected.includes(index) ? '-active' : ''}.svg`)
                    "
                    alt=""
                />
            </div>

            <img
                class="file-icon"
                name="eddxFileIcon"
                @mouseenter="mouseover($event, file)"
                @mouseleave="mouseout"
                src="@/home/assets/pcview/file.svg"
                alt=""
            />

            <span :title="fileName">{{ fileName }}</span>

            <div
                class="list-viewonly"
                v-if="!vip && !['recycle', 'team', 'publishFile'].includes(type) && ((file.info && file.info.edit) || file.edit)"
            >
                <p :title="$t('editor')">{{ $t("editor") }}</p>
            </div>
        </div>

        <template v-if="type == 'share'">
            <div class="file-time" :title="fileTime">{{ fileTime }}</div>
            <div class="file-size file-pv">{{ file.pv }}</div>
        </template>

        <template v-else-if="type == 'shareToMe'">
            <div class="file-time shareToMe-time" :title="fileTime">{{ fileTime }}</div>
            <div class="file-creator" :title="file.creator">{{ file.creator }}</div>
            <div class="file-permission" :title="getPermission(file.permission)">{{ getPermission(file.permission) }}</div>
        </template>

        <template v-else-if="type == 'publishFile'">
            <div class="file-time" :title="fileTime">{{ fileTime }}</div>
            <div class="file-size file-pv">{{ file.used }}</div>
        </template>

        <template v-else-if="type == 'team'">
            <div class="file-time file-time-team">{{ fileTime }}</div>
            <div class="file-creator file-creator-team" :title="file.info.creator && file.info.creator.nick_name">
                {{ file.info.creator && file.info.creator.nick_name }}
            </div>
            <div class="file-size file-size-team">{{ renderSize(file.size) }}</div>
        </template>

        <template v-else-if="type == 'files'">
            <div class="file-time files-time" :title="fileTime">{{ fileTime }}</div>
            <div
                class="file-customtag"
                :class="{ 'keep-expand': fileTagStr(file.info.custom_tag) != $t('tag') }"
                @click.stop
                :title="fileTagStr(file.info.custom_tag)"
            >
                <p @click.prevent.stop="clickTagStr($event, index)">{{ fileTagStr(file.info.custom_tag) }}</p>
                <iconSymbol @click.prevent.stop.native="clickTagStr($event, index)" class="file-customtag-arrow" name="filesitem-arrow" />
            </div>
            <div class="file-size">{{ renderSize(file.size) }}</div>
        </template>

        <template v-else-if="type == 'recycle'">
            <div class="file-time" :title="fileTime">{{ fileTime }}</div>
            <div class="file-size">{{ renderSize(file.size) }}</div>
            <div class="file-notes" :title="$t('expireDate', { date: file.remain_time })">{{ $t("expireDate", { date: file.remain_time }) }}</div>
        </template>

        <template v-else>
            <div class="file-time" :title="fileTime">{{ fileTime }}</div>
            <div class="file-size">{{ renderSize(file.size) }}</div>
        </template>

        <div class="file-select" v-if="!['shareToMe', 'publishFile', 'recycle'].includes(type)">
            <div
                class="list-star"
                v-if="file.info && ['files', 'openRecord', 'star'].includes(type) && !pcSaveInput"
                :class="{ active: file.info.start_tag && file.info.start_tag != 0 }"
                @dblclick.stop=""
            >
                <div class="list-star-block" @click.stop="setStarFile(file)">
                    <iconSymbol :class="{ active: file.info.start_tag == 1 }" name="filesitem-star" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    import fileItem from "../fileItem";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class listFile extends Mixins(fileItem) {
        @Prop() mulSelectMode: boolean;

        iconFunc(key) {
            return require(`@/home/assets/pcview${this.isPCDarkMode == 2 ? "-dark" : ""}/${key}.svg`);
        }

        fileTagStr(tag) {
            // 根据custom_tag返回对应文案
            let list = {
                edraw_0: "tag",
                edraw_1: "waitdone",
                edraw_2: "done",
                edraw_3: "waitchange",
            };
            let str = tag ? this.$t(list[tag]) : this.$t(list["edraw_0"]);
            return str || tag;
        }
        setThumbState(type, data) {
            this.$store.commit("setThumbState", {
                type,
                data,
            });
        }

        renderSize(size) {
            let s = size / 1024 / 1024;
            if (s > 1) {
                return s.toFixed(2) + "M";
            } else {
                return (size / 1024).toFixed(0) + "KB";
            }
        }
        mouseover(e, item) {
            let src = this.fileImg;
            let header;

            if (this.isPC) {
                header = 0;
            } else {
                header = document.querySelector(".user-Topbar").clientHeight;
            }

            this.setThumbState("src", src);
            this.setThumbState("top", e.pageY);
            this.setThumbState("left", e.pageX + 24);
            // this.thumbnail.src = src
            // this.thumbnail.top = e.pageY
            // this.thumbnail.left = e.pageX + 30

            if (window.innerHeight - e.pageY < 200) {
                this.setThumbState("top", this.thumbnail.top - 140);
                // this.thumbnail.top -= 140
            }
            if (window.innerWidth - e.pageX < 200) {
                this.setThumbState("left", this.thumbnail.left - 117);
                // this.thumbnail.left -= 117
            }

            this.thumbnailTimer = setTimeout(() => {
                clearTimeout(this.thumbnailTimer);
                this.setThumbState("state", true);
            }, 300);
        }

        mouseout() {
            clearTimeout(this.thumbnailTimer);
            this.setThumbState("state", false);
        }

        getPermission(index) {
            return [this.$t("read"), this.$t("editor"), this.$t("share")][index];
        }

        listFileClickEvent(index, file = null) {
            if (this.pcSaveInput) {
                this.$emit("changeSaveInputName", this.fileName);
                this.selectFile(index);
                return; // 屏蔽pc保存文件状态
            }
            if (this.mulSelectMode) {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            } else {
                this.openFiles(file);
            }
        }
        ctrlSelect(index) {
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            this.selectFiles(index);
            this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            this.fileSelected.length > 1 && !this.mulSelectMode && this.$emit("enterMulSelectMode");
        }
        selectEvent(index) {
            this.$emit("closeContextmenu");
            if (this.pcSaveInput) return; // 屏蔽pc保存文件状态
            if (!this.mulSelectMode && this.fileSelected[0] == index) {
                // 其他操作下可能有选择单个文件的情景出现
                this.selectFiles(index);
            } else if (!this.mulSelectMode) {
                this.selectFile(index);
                this.$emit("enterMulSelectMode");
            } else {
                this.selectFiles(index);
                this.fileSelected.length == 0 && this.$emit("cancelMulSelectMode");
            }
        }
        contextmenuEvent() {
            this.$emit("contextmenuEvent");
        }
        setStarFile(file) {
            this.$emit("setStarFile", file);
        }
        clickTagStr(e, index) {
            this.selectFile(index);
            this.$emit("clickTagStr", e);
        }
        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "passPublish": "已公开",
    "pendingPublish": "发布中",
    "read": "仅预览",
    "editor": "可编辑",
    "share": "可查看编辑分享",
    "teamEditWarn": "正在编辑该文件",
    "tag": "标签",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "expireDate": "{date}天后永久删除"
  },
  "en": {
    "passPublish": "Public",
    "pendingPublish": "Announcing",
    "read": "View only",
    "editor": "Editable",
    "share": "Can view and edit sharing",
    "teamEditWarn": "Editing this file",
    "tag": "Tag",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "expireDate": "Permanently deleted after {date} days"
  },
  "fr": {
    "passPublish": "Publique",
    "pendingPublish": "Annoncer",
    "read": "Voir seulement",
    "editor": "Modifiable",
    "share": "Peut afficher et modifier le partage",
    "teamEditWarn": "Modifier ce fichier",
    "tag": "étiqueter",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié"
  },
  "de": {
    "passPublish": "Öffentlichkeit",
    "pendingPublish": "ankündigen",
    "read": "Nur anschauen",
    "editor": "Editierbar",
    "share": "Kann die Freigabe anzeigen und bearbeiten",
    "teamEditWarn": "Dieser Datei wird bearbeitet",
    "tag": "Etikette",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar"
  },
  "jp": {
    "passPublish": "公開済み",
    "pendingPublish": "公開中",
    "read": "閲覧のみ",
    "editor": "編集可能",
    "share": "共有を表示および編集できます",
    "teamEditWarn": "ファイルを編集しています。",
    "tag": "ラベル",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定"
  },
  "es": {
    "passPublish": "Público",
    "pendingPublish": "Anunciando",
    "read": "Sólo vista",
    "editor": "Editable",
    "share": "Puede ver y editar compartir",
    "teamEditWarn": "Editando este archivo",
    "tag": "etiqueta",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar"
  },
  "pt": {
    "passPublish": "Público",
    "pendingPublish": "Anunciando",
    "read": "Apenas ver",
    "editor": "Editável",
    "share": "Pode ver e editar o compartilhamento",
    "teamEditWarn": "Editando este arquivo",
    "tag": "rótulo",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado"
  },
  "it": {
    "passPublish": "Pubblico",
    "pendingPublish": "Annunciando",
    "read": "Visualizzare solamente",
    "editor": "Modificabile",
    "share": "Può visualizzare e modificare la condivisione",
    "teamEditWarn": "Modifica questo file",
    "tag": "etichetta",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare"
  },
  "tw": {
    "passPublish": "已公開",
    "pendingPublish": "發佈中",
    "read": "僅查看",
    "editor": "可編輯",
    "share": "可查看編輯分享",
    "teamEditWarn": "正在編輯該檔案",
    "tag": "標籤",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改"
  },
  "kr": {
    "passPublish": "공개 파일",
    "pendingPublish": "게시 중",
    "read": "보기만 가능",
    "editor": "편집 가능",
    "share": "보기,편집,공유 모두 가능",
    "teamEditWarn": "파일 편집 중",
    "tag": "태그",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요"
  },
  "id": {
    "passPublish": "Publik",
    "pendingPublish": "Mengumumkan",
    "read": "Hanya lihat",
    "editor": "Edit",
    "share": "Dapat melihat dan mengedit pemakaian bersama",
    "teamEditWarn": "Mengedit file ini",
    "tag": "Tag",
    "none": "Tidak",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi"
  }
}
</i18n>
